import { useParams } from "react-router-dom";

import ExploreHseContextsExternal from "shared/pages/exploreHseContextsNew/exploreHseContextsExternal";

const COUNTRIES_ID_INDEX = {
  armenia: '5568a2b687af413c90bc2ae5185c9a9b',
  uzbekistan: 'f75fffafeea3482fb65358adeb776ee5',
  india: 'd395add1d7db4406bfaa396feafe99be',
  kazakhstan: 'a455415c44404db4b470df9fab7167a0',
  belarus: 'e301d5a7a1f349e3afe2c314beec7935',
  kyrgyzstan: 'eb4fb91619f64d4b888d126d435f1acb',
  moldova: 'fdd86dc57ed94e34b5a2b7e11fc2cb3a',
  china: '15f9ae26241142d198eeb4c3c21ed2de',
  abkhazia: 'cdfdc030430446179a282bb976f9cddb',
  azerbaijan: '8d897594349240d48bcfe1ef79dc7aca',
  vietnam: 'f6591773d3584d30b2d7e982ccb54810',
  turkmenistan: '5744b32e69e345009a1d4e4a8203286f',
  latvia: 'c58e2a123f40487695bd6099b5b5e34e'
}

export const COUNTRY_CODES = {
  armenia: 'ARM',
  uzbekistan: 'UZB',
  india: 'IND',
  kazakhstan: 'KAZ',
  belarus: 'BLR',
  kyrgyzstan: 'KGZ',
  moldova: 'MDA',
  china: 'CHN',
  abkhazia: 'ABH',
  azerbaijan: 'AZE',
  vietnam: 'VNM',
  turkmenistan: 'TKM',
  latvia: 'LVA'
};


const CountryShowcase = () => {
    // @ts-ignore
    const { id } = useParams();
    // @ts-ignore
    const teamId = COUNTRIES_ID_INDEX[id]

    return <ExploreHseContextsExternal context={teamId} />
}

export default CountryShowcase;import { useParams } from "react-router-dom";

import ExploreHseContextsExternal from "shared/pages/exploreHseContextsNew/exploreHseContextsExternal";

const COUNTRIES_ID_INDEX = {
  armenia: '5568a2b687af413c90bc2ae5185c9a9b',
  uzbekistan: 'f75fffafeea3482fb65358adeb776ee5',
  india: 'd395add1d7db4406bfaa396feafe99be',
  kazakhstan: 'a455415c44404db4b470df9fab7167a0',
  belarus: 'e301d5a7a1f349e3afe2c314beec7935',
  kyrgyzstan: 'eb4fb91619f64d4b888d126d435f1acb',
  moldova: 'fdd86dc57ed94e34b5a2b7e11fc2cb3a',
  china: '15f9ae26241142d198eeb4c3c21ed2de',
  abkhazia: 'cdfdc030430446179a282bb976f9cddb',
  azerbaijan: '8d897594349240d48bcfe1ef79dc7aca',
  vietnam: 'f6591773d3584d30b2d7e982ccb54810',
  turkmenistan: '5744b32e69e345009a1d4e4a8203286f',
  latvia: 'c58e2a123f40487695bd6099b5b5e34e'
}

export const COUNTRY_CODES = {
  armenia: 'ARM',
  uzbekistan: 'UZB',
  india: 'IND',
  kazakhstan: 'KAZ',
  belarus: 'BLR',
  kyrgyzstan: 'KGZ',
  moldova: 'MDA',
  china: 'CHN',
  abkhazia: 'ABH',
  azerbaijan: 'AZE',
  vietnam: 'VNM',
  turkmenistan: 'TKM',
  latvia: 'LVA'
};


const CountryShowcase = () => {
    // @ts-ignore
    const { id } = useParams();
    // @ts-ignore
    const teamId = COUNTRIES_ID_INDEX[id]

    return <ExploreHseContextsExternal context={teamId} />
}

export default CountryShowcase;